import React, { } from 'react'
import { useResponsiveSize } from './hooks'
import { ImageComp } from './image'

export const CustomModal = ({ opened, closeFunc, width, style = {}, padding = 45, otherStyle = {}, children, }) => {
    const getResponsiveSize = useResponsiveSize()
    return (
        <>
            {opened ? (
                <div
                    style={{
                        position: 'fixed',
                        zIndex: 30,
                        left: 0, right: 0,
                        top: -300, bottom: -300,
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onMouseDown={event => event.stopPropagation()}
                >
                    <div style={{
                        position: 'relative',
                        width: width,
                        backgroundColor: '#fff',
                        margin: 0,
                        padding: 0,
                        ...style
                    }}>
                        <div style={{
                            width: '100%',
                            textAlign: 'right',
                        }}>
                            <ImageComp
                                src={"/static/UI/btn-close-black.png"}
                                style={{
                                    width: getResponsiveSize(24, 24),
                                    height: getResponsiveSize(24, 24),
                                    cursor: 'pointer',
                                    margin: getResponsiveSize(20, 19)
                                }}
                                onClick={closeFunc}
                                alt="close"
                            />
                        </div>
                        <div style={{
                            width: `calc(100% - ${2 * padding}px)`,
                            paddingLeft: padding, paddingRight: padding,
                            marginBottom: getResponsiveSize(36, 36),
                            overflowX: 'hidden', overflowY: 'auto',
                            ...otherStyle
                        }}>
                            {
                                children
                            }
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export const TransparentFullScreenModal = ({ opened = false, children }) => {
    return (
        opened ?
            <div style={{
                position: 'fixed', zIndex: 30,
                left: 0, right: 0, top: 0, bottom: 0,
                background: 'rgba(0, 0, 0, 0.8)',
                color: 'rgba(255, 255, 255, 0.8)'
            }}>
                {children}
            </div> : null
    )
}
